import {Children, cloneElement, HTMLAttributes, isValidElement} from 'react';
import {twMerge} from '../../../common/twMerge';
import {ErrorAreaContext} from './ErrorAreaContext';
import {
  ErrorAreaDetailText,
  ErrorAreaDetailTextType,
} from './ErrorAreaDetailText';
import {ErrorAreaImage, ErrorAreaImageType} from './ErrorAreaImage';
import {
  ErrorAreaLabelButton,
  ErrorAreaLabelButtonType,
} from './ErrorAreaLabelButton';
import {ErrorAreaMainText, ErrorAreaMainTextType} from './ErrorAreaMainText';
import {
  ErrorAreaPcAppScheme,
  ErrorAreaPcAppSchemeType,
} from './ErrorAreaPcAppScheme';
import {
  ErrorAreaTextButton,
  ErrorAreaTextButtonType,
} from './ErrorAreaTextButton';
import {ErrorAreaTitle, ErrorAreaTitleType} from './ErrorAreaTitle';
import {getByType} from './functions';

function ErrorAreaMain({
  isMobile,
  isDesignFree = false,
  children,
  className,
  isPopupWindow,
  ...props
}: {
  isMobile: boolean;
  isPopupWindow?: boolean;
  isDesignFree?: boolean;
} & HTMLAttributes<HTMLDivElement>) {
  const title = getByType({children, type: ErrorAreaTitleType});
  const mainText = getByType({children, type: ErrorAreaMainTextType});
  const detailText = getByType({children, type: ErrorAreaDetailTextType});
  const labelButton = getByType({children, type: ErrorAreaLabelButtonType});
  const textButton = getByType({children, type: ErrorAreaTextButtonType});
  const image = getByType({children, type: ErrorAreaImageType});
  const pcAppScheme = getByType({children, type: ErrorAreaPcAppSchemeType});

  return (
    <ErrorAreaContext.Provider value={{isMobile, isPopupWindow}}>
      <div
        className={twMerge('bg-theme-bg-base flex-center-full', className)}
        {...props}
      >
        {isDesignFree ? (
          Children.map(children, child => {
            if (isValidElement(child)) {
              return getByType({children: child, type: child.type});
            }
          })
        ) : (
          <>
            {title && isValidElement(title) && (
              <>{cloneElement(title as React.ReactElement<any>, {isMobile})}</>
            )}
            {mainText && <div className="mt-8pxr">{mainText}</div>}
            {detailText && <div className="mt-8pxr">{detailText}</div>}
            {image && <div className="mt-32pxr mb-40pxr">{image}</div>}
            {labelButton && isValidElement(labelButton) && (
              <div className={isMobile ? 'mt-16pxr' : 'mt-32pxr'}>
                {cloneElement(
                  labelButton as React.ReactElement<any>,
                  isMobile
                    ? {isRound: true}
                    : {
                        isRound: false,
                        className: 'w-320pxr h-48pxr font-medium1-bold',
                      }
                )}
              </div>
            )}
            {textButton && <div className="mt-16pxr">{textButton}</div>}
            {pcAppScheme && <div>{pcAppScheme}</div>}
          </>
        )}
      </div>
    </ErrorAreaContext.Provider>
  );
}

export const ErrorArea = Object.assign(ErrorAreaMain, {
  Title: ErrorAreaTitle,
  MainText: ErrorAreaMainText,
  DetailText: ErrorAreaDetailText,
  LabelButton: ErrorAreaLabelButton,
  TextButton: ErrorAreaTextButton,
  Image: ErrorAreaImage,
  PcAppScheme: ErrorAreaPcAppScheme,
});
